import * as SVG from '../svg/svg'
import { GeodeticBounds } from './map-types';
import { markup2element } from '../dom/dom';
import { TimedSVGResult } from './svg-overlay-result'

export interface MapOverlaySVGResult extends GeodeticBounds {
    elem: SVGElement,
    viewBox: SVG.ViewBox, 
    build : {
        start: number,
        end: number,
        time: number 
    }
}

export const markupToSVGElemResult = ( timedSVGResult: TimedSVGResult ): MapOverlaySVGResult  => {
  let elemResult = Object.assign({ elem: <SVGElement>markup2element(timedSVGResult.content) }, timedSVGResult);
  delete elemResult.content;
  return elemResult;
}